const serviceKinds = [
    'Akumulatory z montażem',
    'Alarmy z montażem',
    'Awaryjne otwieranie',
    'Car audio i nawigacja',
    'CB radia',
    'Części zawieszenia z montażem',
    'Dorabianie i kodowanie kluczy samochodowych',
    'Elektryk samochodowy',
    'Elementy zapłonu z montażem',
    'Folie z montażem ',
    'Haki holownicze z montażem',
    'Instalacje LPG',
    'Kontrola spalin',
    'Kosmetyka pojazdów (car detailing)',
    'Naprawa układu hamulcowego',
    'Naprawa pomp wtryskowych',
    'Naprawa przekładni kierowniczej',
    'Naprawa układu kierowniczego',
    'Naprawy blacharsko-lakiernicze',
    'Obsługa klimatyzacji',
    'Ogrzewanie postojowe z montażem',
    'Oleje i filtry z wymianą',
    'Paski rozrządu z montażem',
    'Pomiary zbieżności',
    'Pomoc drogowa',
    'Przeglądy kontrolne',
    'Przeglądy rejstracyjne',
    'Przyciemnianie szyb',
    'Regeneracja skrzyni biegów',
    'Rozruszniki z montażem',
    'Serwis ogumienia',
    'Transport samochodów',
    'Tuning',
    'Wymiana i naprawa szyb',
    'Złomowanie pojazdów',
    'Pozostałe',
]

export default serviceKinds